export const PUBLIC_ASSETS = {
  favicon: '/common/favicon.svg',
  hero: '/common/hero.png',
  icons: '/common/icons.svg',
  react: '/common/react.svg',
  vite: '/common/vite.svg',
  bgImageErrorPage: '/background/bg-image-error-page.png',
  bgTextureSquare: '/background/bg-texture-square.svg',
  nutriseeLogo: '/logo/nutrisee.png',
  nutriseeFavicon: '/logo/nutrisee-favicon.png',
  error403: '/error/error-403.png',
  error404: '/error/error-404.png',
  error500: '/error/error-500.png',
  maintenance: '/error/maintenance.png',
  authIlustration: '/auth/auth-illustration.png',
};
